import { inject, Injectable } from '@angular/core';
import { CONFIG } from '@proman/config';
import { PromanDialogService } from '@proman/dialog/proman-dialog.service';
import { PromanFile } from '@proman/interfaces/entity-interfaces';
import { RequestService } from '@proman/services/request.service';
import { ToastService } from '@proman/services/toast.service';
import { SmartsignSigningDialogComponent } from '@proman/shared-dialogs/dialogs/smartsign-signing-dialog.component';

declare interface SignerLink {
    email: string;
    url: string;
}

declare interface SignRequestResponse {
    documentId: number;
    status: string;
    signerLinks: SignerLink[];
}

@Injectable({
    providedIn: 'root',
})
export class SmartsignService {
    Dialog = inject(PromanDialogService);
    Request = inject(RequestService);
    Toast = inject(ToastService);

    connect() {
        return this.Request.post(CONFIG.api + 'smartsign/connect');
    }

    smartsign = (file: PromanFile) => {
        if (file.extension !== 'pdf') {
            this.Toast.pop('error', 'only_pdf_files_supported');
            return;
        }

        this.Dialog.open(SmartsignSigningDialogComponent, {}).then((result: { signers: number[] }) => {
            this.Request.post(CONFIG.api + 'smartsign/sign_document', { id: file.id, signers: result.signers }).then(
                (response: SignRequestResponse) => {
                    const tmpLink = response.signerLinks[0];
                    window.open(tmpLink.url, '_blank');
                }
            );
        });
    };
}
